import { render } from "./committee.vue?vue&type=template&id=26e612ed&scoped=true"
import script from "./committee.vue?vue&type=script&lang=ts"
export * from "./committee.vue?vue&type=script&lang=ts"

import "./committee.vue?vue&type=style&index=0&id=26e612ed&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-26e612ed"

export default script